import PayStubChooseTemplate from './PayStubChooseTemplate'

export default PayStubChooseTemplate
